export const IS_TH = false;
export const IS_BK = false;
export const DOCUMENT_TITLE = 'documentTitle.fhs';
